import React, { useState, useEffect } from 'react';
import request from '@/services/request.service';
import { getLocaleWordContent } from '@/utils/language.util';
import countryCode from '@/resources/data/object/countryCode.json';
const SignUpInputItem = ({
    type,
    message,
    value,
    onChangeInput,
    onValidateMsg,
    placeholder,
    name,
    itemClass,
    convert,
    children,
    ...rest
}) => {
    const refineName = name.split('.')[1];
    return (
        <p className={['input-item', itemClass && itemClass].join(' ').trim()}>
            {convert ? (
                children
            ) : (
                <input
                    type={type}
                    value={value || ''}
                    onChange={onChangeInput}
                    placeholder={placeholder}
                    name={name}
                    onBlur={() => onValidateMsg(refineName)}
                    autoComplete="off"
                    {...rest}
                />
            )}
            {message && <span className="input-error-message">{message[refineName]}</span>}
        </p>
    );
};

export default function SignUpInput({
    user,
    onChangeInput,
    message,
    onValidateMsg,
    onSmsSend,
    onSmsAuth,
    onHandleBlurId,
    onHandleBlur,
    onHandleBlur2,
    smsMsg,
    smsAuth,
    ...rest
}) {
    const [center, setCenter] = useState([]);
    const getListProduct = async () => {
        const rsp = await request.post('/api/account/center_list.php').then((response) => response.data);

        if (rsp.result < 0) {
            window.alert(rsp.msg);
        } else {
            setCenter(rsp.list);
            return rsp.list;
        }
    };
    const fetchBusinesses = () => {
        getListProduct();
    };
    useEffect(fetchBusinesses, []);

    return (
        <>
            <input type="name" style={{ opacity: '0', position: 'absolute' }} />
            <input type="text" id="user.s_id s_id" style={{ opacity: '0', position: 'absolute' }} />

            <input
                type="password"
                style={{ opacity: '0', position: 'absolute' }}
                name="password_auto"
                autoComplete="false"
            />
            <div className="input_form">
                <p className="title">{getLocaleWordContent('이름')}</p>
                <SignUpInputItem
                    type="name"
                    className="input01"
                    value={user.c_name}
                    onChangeInput={onChangeInput}
                    message={message}
                    onValidateMsg={onValidateMsg}
                    {...rest}
                    name="user.c_name"
                    required
                    placeholder={getLocaleWordContent('실명으로 입력하세요.')}
                    autoComplete="off"
                />
            </div>

            <div className="d_flex">
                <div className="input_form">
                    <p className="title">{getLocaleWordContent('국가번호')}</p>
                    <select
                        name="user.country"
                        className="select_phone"
                        value={user.country}
                        onChange={onChangeInput}
                        required
                    >
                        <option value="" disabled hidden>
                            Country
                        </option>
                        {countryCode.map((item, index) => (
                            <option key={index} value={[item.name, item.code]}>
                                {item.name}{' '}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="input_form">
                    <p className="title">{getLocaleWordContent('전화번호')}</p>
                    <input
                        type="tel"
                        id="user_phone"
                        className="input01"
                        name="user.phone"
                        value={user.phone}
                        onChange={onChangeInput}
                        onBlur={() => onValidateMsg('tel')}
                        required
                    />
                </div>
            </div>

            <div className="input_form">
                <p className="title">{getLocaleWordContent('아이디')}</p>
                <input
                    type="text"
                    className="input01"
                    value={user.userid}
                    onChange={onChangeInput}
                    message={message}
                    onBlur={(e) => onHandleBlurId(e)}
                    {...rest}
                    name="user.userid"
                    required
                    placeholder={getLocaleWordContent('아이디(4자리이상,영문번호)')}
                    autoComplete="off"
                />
            </div>

            <div className="input_form">
                <p className="title">{getLocaleWordContent('비밀번호')}</p>
                <SignUpInputItem
                    type="new-password"
                    className="input01"
                    value={user.pass}
                    onChangeInput={onChangeInput}
                    message={message}
                    onValidateMsg={onValidateMsg}
                    {...rest}
                    name="user.pass"
                    required
                    autoComplete="off"
                    placeholder={getLocaleWordContent('비밀번호를 입력해주세요.')}
                />
            </div>

            <div className="input_form">
                <p className="title">{getLocaleWordContent('비밀번호 확인')}</p>
                <SignUpInputItem
                    type="new-password"
                    className="input01"
                    value={user.pass_cfm}
                    onChangeInput={onChangeInput}
                    message={message}
                    onValidateMsg={onValidateMsg}
                    {...rest}
                    name="user.pass_cfm"
                    required
                    autoComplete="off"
                    placeholder={getLocaleWordContent('비밀번호를 확인 입력해주세요.')}
                />
            </div>
            {/* add bank*/}
            <div className="input_form">
                <p className="title">{getLocaleWordContent('핀번호')}</p>
                <SignUpInputItem
                    type="text"
                    className="input01"
                    value={user.pin}
                    onChangeInput={onChangeInput}
                    message={message}
                    onValidateMsg={onValidateMsg}
                    {...rest}
                    name="user.pin"
                    required
                    placeholder={getLocaleWordContent('핀번호 4자리를 입력해주세요.')}
                />
            </div>

            <div className="input_form">
                <p className="title">{getLocaleWordContent('핀번호 확인')}</p>
                <SignUpInputItem
                    type="text"
                    className="input01"
                    value={user.pin_cfm}
                    onChangeInput={onChangeInput}
                    message={message}
                    onValidateMsg={onValidateMsg}
                    {...rest}
                    name="user.pin_cfm"
                    required
                    placeholder={getLocaleWordContent('핀번호를 확인 입력해주세요.')}
                />
                {/* <input type="button" value={'확인'} /> */}
            </div>
            {/* reffal */}
            <div className="input_form">
                <p className="title">{getLocaleWordContent('추천아이디')}</p>
                <input
                    type="text"
                    className="input01"
                    value={user.referral}
                    onChange={onChangeInput}
                    message={message}
                    {...rest}
                    id="user.referral"
                    name="user.referral"
                    required
                    placeholder={getLocaleWordContent('추천아이디 입력하세요.')}
                    onBlur={(e) => onHandleBlur(e)}
                    autoComplete="off"
                />
            </div>
            <div className="input_form">
                <p className="title">{getLocaleWordContent('추천이름')}</p>
                <input
                    type="text"
                    className="input01"
                    value={user.referral_name}
                    onChange={onChangeInput}
                    message={message}
                    {...rest}
                    name="user.referral_name"
                    required
                    autoComplete="off"
                />
            </div>
            {/* Sponsor */}
            <div className="input_form">
                <p className="title">{getLocaleWordContent('후원인아이디')}</p>
                <SignUpInputItem
                    type="text"
                    className="input01"
                    value={user.s_id}
                    onChange={onChangeInput}
                    message={message}
                    {...rest}
                    id="user.s_id"
                    name="user.s_id"
                    required
                    placeholder={getLocaleWordContent('후원인 아이디 입력하세요.')}
                    autoComplete="off"
                    onBlur={(e) => onHandleBlur2(e)}
                />
            </div>
            <div className="input_form">
                <p className="title">{getLocaleWordContent('후원인이름')}</p>
                <input
                    type="text"
                    className="input01"
                    value={user.spon_name}
                    onChange={onChangeInput}
                    message={message}
                    {...rest}
                    name="user.spon_name"
                    required
                    autoComplete="off"
                />
            </div>
            {/* center */}
            <div className="input_form">
                <p className="title">{getLocaleWordContent('센터')}</p>
                {/* <input
                    type="text"
                    className="input01"
                    value={user.center}
                    onChange={onChangeInput}
                    message={message}
                    {...rest}
                    name="user.center"
                    placeholder={'센터선택'}
                /> */}
                <select
                    name="user.center"
                    value={user.center}
                    className="select_center"
                    onChange={onChangeInput}
                    required
                >
                    <option value="" disabled hidden>
                        {getLocaleWordContent('센타를 클릭하면')}
                    </option>
                    {center &&
                        center.map((item, index) => (
                            <option key={index} value={[item.c_name]}>
                                {item.c_name}
                            </option>
                        ))}
                </select>
            </div>
        </>
    );
}
